/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface SchoolInfo { 
    redIzo: string;
    ico: string;
    nazev: string;
    pravniForma: string;
    adresa: string;
    street: string;
    streetNumber: string;
    city: string;
    zipCode: string;
    emails: Array<string>;
    reditelNazev: string;
    reditelAdresa: string;
    zrizovatelNazev: Array<string>;
    zrizovatelEmail: Array<string>;
    zrizovatelAdresa: Array<string>;
    facilities: Array<{ [key: string]: any; }>;
}